export function isClickAnalyticsRuntimeEnabled(
  configuredValue: string | undefined,
  isBackoffice: boolean,
): boolean {
  return configuredValue === 'true' && !isBackoffice;
}
